import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Icon, Popup, Divider, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import moment from 'moment';

import { colors, nbColors } from 'utils/colors';
import { isNB } from '../utils/helpers';
import Calendar from './Calendar';

class Score extends Component {
  state = {
    changeDateModalOpen: false,
    selectedInitDate: '',
  };

  getLatestSelectableDate = (portfolio) =>
    moment(portfolio.end_date, 'YYYY-MM-DD')
      .subtract(1, 'month')
      .format('YYYY-MM-DD');

  parseDate = (portfolio) => {
    const init = portfolio.init_date.split('-');
    const end = portfolio.end_date.split('-');

    return `${init[1]}/${init[0]} - ${end[1]}/${end[0]}`;
  };

  parseDescription = (description) => {
    if (typeof description === 'string') {
      return description.split('<br />').map((paragraph, index) => (
        <p
          style={{
            fontSize: '1rem',
          }}
          key={index}
        >
          {paragraph}
        </p>
      ));
    }
    return description;
  };

  openChangeDateModal = () => {
    this.setState({
      changeDateModalOpen: true,
      selectedInitDate: this.props.portfolio.init_date,
    });
  };

  closeChangeDateModal = () => {
    this.setState({ changeDateModalOpen: false });
  };

  changeInitDate = () => {
    const { onChangeInitDate } = this.props;
    const { selectedInitDate } = this.state;

    this.closeChangeDateModal();
    return onChangeInitDate(selectedInitDate);
  };

  resetToDefault = () => {
    this.setState({ selectedInitDate: this.props.minInitDate });
  };

  isSelectedInitDateValid = () => {
    const { portfolio, minInitDate } = this.props;
    const { selectedInitDate } = this.state;
    const selectedDate = moment(selectedInitDate, 'YYYY-MM-DD', true);
    const minDate = moment(minInitDate, 'YYYY-MM-DD', true);
    const maxDate = moment(
      this.getLatestSelectableDate(portfolio),
      'YYYY-MM-DD',
      true
    );

    return (
      selectedDate.isValid() &&
      minDate.isValid() &&
      maxDate.isValid() &&
      !selectedDate.isBefore(minDate, 'month') &&
      !selectedDate.isAfter(maxDate, 'month')
    );
  };

  render() {
    const {
      name,
      score,
      portfolio,
      grade,
      description,
      boldDate,
      analytics,
      french,
      partnerName,
      pdf,
      extraInfo,
      onChangeInitDate,
      minInitDate,
    } = this.props;
    const { printParams } = analytics;
    const { printLetterGrade, printModal } = printParams;
    return (
      <div>
        <StyledScore grade={grade} partnerName={partnerName}>
          {printLetterGrade === false && !printModal ? (
            <div>
              <span style={{ visibility: 'hidden' }}>
                {french ? 'Note globale ' : 'Overall Score '}
              </span>
              {portfolio && (
                <span className="date">
                  {boldDate ? (
                    <b>{this.parseDate(portfolio)}</b>
                  ) : (
                    this.parseDate(portfolio)
                  )}
                </span>
              )}
            </div>
          ) : (
            <div
              style={{
                marginBottom: pdf
                  ? '1rem'
                  : portfolio &&
                    portfolio.account &&
                    portfolio.account.user_institution ===
                      'Overview; All Accounts'
                  ? '3.6rem'
                  : portfolio &&
                    portfolio.account &&
                    portfolio.account.user_institution &&
                    !portfolio.account.institution
                  ? '2.2rem'
                  : portfolio &&
                    portfolio.name &&
                    portfolio.description &&
                    portfolio.description.length > 90
                  ? '4.9rem'
                  : (portfolio &&
                      portfolio.account &&
                      Object.keys(portfolio.account).length) ||
                    (portfolio && portfolio.name && portfolio.description)
                  ? '3.6rem'
                  : portfolio && portfolio.name
                  ? '2.14rem'
                  : '1.8rem',
              }}
            >
              {name || (french ? 'Note globale ' : 'Overall Score ')}
              {!!description && (
                <Popup
                  style={{ fontSize: '1rem' }}
                  trigger={
                    <Icon
                      name="question circle outline"
                      style={{
                        fontSize: '15px',
                        verticalAlign: 'initial',
                        color: 'dimgrey',
                        marginRight: '1rem',
                      }}
                    />
                  }
                  position="right center"
                  wide
                  hoverable
                >
                  <Popup.Content
                    style={{
                      fontSize: '1rem',
                    }}
                  >
                    {this.parseDescription(description)}
                  </Popup.Content>
                </Popup>
              )}
              {score}
              <Popup
                style={{
                  fontSize: '1rem',
                }}
                trigger={
                  <a
                    className={`grade ${isNB(partnerName) && 'nb'}`}
                    href={
                      french
                        ? 'https://www.wealthscope.ca/why-scores-fr'
                        : 'https://www.wealthscope.ca/whyscores'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {grade}
                  </a>
                }
                position="right center"
              >
                <Popup.Header>
                  {french ? 'Pourquoi les scores?' : 'Why Scores?'}
                </Popup.Header>
                <Popup.Content
                  style={{
                    fontSize: '1rem',
                  }}
                >
                  {french
                    ? 'Cliquez sur la note pour lire un article sur le fonctionnement de nos scores.'
                    : 'Click the letter grade to read an article on how our scores work.'}
                </Popup.Content>
              </Popup>
              {extraInfo && (
                <span
                  style={{
                    display: 'inline-block',
                    marginLeft: '0.75rem',
                    fontSize: '1.14rem',
                    fontWeight: 'normal',
                    verticalAlign: 'middle',
                  }}
                >
                  {extraInfo}
                </span>
              )}

              {portfolio && (
                <span className="date">
                  {boldDate ? (
                    <b>{this.parseDate(portfolio)}</b>
                  ) : (
                    this.parseDate(portfolio)
                  )}
                  {onChangeInitDate && (
                    <EditDateIcon
                      aria-label={
                        french
                          ? 'Modifier la date de début'
                          : 'Change analysis start date'
                      }
                      name="pencil"
                      onClick={this.openChangeDateModal}
                      title={
                        french
                          ? 'Modifier la date de début'
                          : 'Change analysis start date'
                      }
                    />
                  )}
                </span>
              )}
            </div>
          )}
        </StyledScore>
        <Divider />
        {onChangeInitDate && portfolio && (
          <StyledModal
            open={this.state.changeDateModalOpen}
            onClose={this.closeChangeDateModal}
            size="tiny"
            centered
            closeOnDimmerClick={false}
            closeIcon={<Icon name="close" className="modal-close-icon" />}
          >
            <StyledModalHeader>
              {french ? 'Modifier la date de début' : 'Change Start Date'}
              <ModalSubtitle>
                {french
                  ? 'Sélectionnez une année et un mois.'
                  : 'Select a year and month.'}
              </ModalSubtitle>
            </StyledModalHeader>
            <Modal.Content>
              <Calendar
                label={french ? 'Date de début' : 'Start date'}
                mode="month"
                value={this.state.selectedInitDate}
                setSelected={(selectedInitDate) =>
                  this.setState({ selectedInitDate })
                }
                minAllowed={minInitDate}
                maxAllowed={this.getLatestSelectableDate(portfolio)}
              />
              <EndDateText>
                {french ? 'Date de fin : ' : 'End date: '}
                {moment(portfolio.end_date, 'YYYY-MM-DD').format(
                  'MMMM YYYY'
                )}{' '}
                {french ? '(fixe)' : '(fixed)'}
              </EndDateText>
            </Modal.Content>
            <Divider style={{ margin: 0 }} />
            <ModalFooter>
              <ResetLink onClick={this.resetToDefault}>
                {french ? 'Réinitialiser' : 'Reset to default'}
              </ResetLink>
              <FooterButtons>
                <Button basic onClick={this.closeChangeDateModal}>
                  {french ? 'Annuler' : 'Cancel'}
                </Button>
                <Button
                  color="blue"
                  disabled={!this.isSelectedInitDateValid()}
                  onClick={this.changeInitDate}
                >
                  {french ? 'Appliquer' : 'Apply'}
                </Button>
              </FooterButtons>
            </ModalFooter>
          </StyledModal>
        )}
      </div>
    );
  }
}

Score.propTypes = {
  portfolio: PropTypes.object.isRequired,
  name: PropTypes.string,
  score: PropTypes.string,
  grade: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  boldDate: PropTypes.bool,
  analytics: PropTypes.object,
  french: PropTypes.bool,
  partnerName: PropTypes.string,
  pdf: PropTypes.bool,
  extraInfo: PropTypes.string,
  onChangeInitDate: PropTypes.func,
  minInitDate: PropTypes.string,
};

Score.defaultProps = {
  name: '',
  score: '',
  grade: '',
  description: '',
  boldDate: false,
  analytics: {},
  french: false,
  partnerName: '',
  pdf: false,
  extraInfo: '',
  onChangeInitDate: null,
  minInitDate: '',
};

export default connect((state) => ({
  analytics: state.Analytics,
  french: state.Storage.language === 'fr',
  partnerName: state.Storage['partner-name'],
}))(Score);

const StyledScore = styled.div`
  position: relative;
  width: 100%;
  font-size: 1.3em;
  font-weight: 700;

  & .grade {
    font-family: 'Kalam', cursive;
    font-size: ${(props) => (props.grade === 'N/A' ? '2.5rem' : '3rem')};
    color: ${(props) => determineColor(props.grade)};
    padding: 0 0.5rem;
    vertical-align: middle;

    &:hover {
      color: ${(props) =>
        isNB(props.partnerName) ? nbColors.blue : 'rgb(97, 124, 246)'};
    }
  }

  & .date {
    font-size: 1rem;
    float: right;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
  }

  Popup {
    font-size: 1rem;
  }
`;

const determineColor = (grade) => {
  if (grade === 'A') {
    return colors.darkBlue;
  }
  if (grade === 'B') {
    return colors.blue;
  }
  if (grade === 'C') {
    return colors.orange;
  }
  if (grade === 'N/A') {
    return 'rgba(0,0,0,0.6)';
  }

  return colors.red;
};

const StyledModal = styled(Modal)`
  &&& {
    border-radius: 12px;
    overflow: hidden;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    width: 100%;
    max-width: 420px;
  }

  &&&& .modal-close-icon {
    top: 1.5rem;
    right: 1.5rem;
    color: rgba(0, 0, 0, 0.5);
    font-size: 1.1rem;
  }
`;

const StyledModalHeader = styled(Modal.Header)`
  &&& {
    border-bottom: none;
    padding: 1.75rem 1.75rem 0.5rem 1.75rem;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

const ModalSubtitle = styled.div`
  font-size: 1rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 0.5rem;
`;

const EndDateText = styled.div`
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 1.25rem;
`;

const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.75rem;
`;

const ResetLink = styled.a`
  color: ${colors.blue};
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const FooterButtons = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const EditDateIcon = styled(Icon)`
  &&& {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.8rem;
    height: 1.8rem;
    margin: 0 0 0 0.2rem;
    color: ${colors.blue};
    cursor: pointer;
    font-size: 18px;
    opacity: 1;
    border-radius: 5px;
    background-color: transparent;
    transition: background-color 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  &&&:hover {
    color: rgb(97, 124, 246);
    background-color: rgba(97, 124, 246, 0.15);
  }
`;
